'use client';

import { Heading, LayoutContainer, TextPassage } from '@petsmart-ui/sparky';
import cn from 'classnames';

import { FaqSeo } from '@libs/common-next';

import { parseRichContentToPlainText } from '../../../utils/parseRichText';
import { useFaqColumns } from './columns.hook';
import { FaqAccordionGroup } from './faq-accordion-group';
import type { FaqProps } from './types';

import './styles.scss';

export type { FaqProps } from './types';

export function Faq({ heading, description, items, columns, className }: FaqProps) {
    const hasStoreCards = items.some(item => item.content.type === 'stores');
    const seoItems = items.flatMap(({ title, content }) => {
        if (content.type !== 'rich-text') {
            return [];
        }

        return [{ question: title, answer: parseRichContentToPlainText(content.document) }];
    });

    const columnStyle = useFaqColumns(items.length, columns);

    return (
        <LayoutContainer className="sparky-u-width-100">
            <div
                className={cn('faq', className, { 'faq-centered': hasStoreCards, 'faq-columns': columnStyle })}
                style={columnStyle}
            >
                <Heading size="title" tagName="h2">
                    {heading}
                </Heading>

                {description && <TextPassage className="faq-subheader">{description}</TextPassage>}

                {items.length > 0 && <FaqAccordionGroup items={items} />}
                <FaqSeo id="faq-seo" qaArray={seoItems} />
            </div>
        </LayoutContainer>
    );
}
